import Store from '@/base/constants/Store.js'

const Device = Object.freeze({
  Iphone: 'iphone',
  Ipad: 'ipad',
  RealityDevice: 'reality_device',
  Android: 'android',
  All: 'all',
})

const StoreDevices = Object.freeze({
  [Store.Play]: [Device.Android],
  [Store.Ios]: [Device.Iphone, Device.Ipad, Device.RealityDevice],
})

const StoreDevicesWithAll = Object.freeze({
  [Store.Play]: StoreDevices[Store.Play].concat(Device.All),
  [Store.Ios]: StoreDevices[Store.Ios].concat(Device.All),
})

export {
  Device as default,
  Device,
  StoreDevices,
  StoreDevicesWithAll,
}
